export enum TranskodeWrapper {
  MXF = "MXF",
  MOV = "MOV",
  MPG = "MPG",
  MP4 = "MP4",
  AVI = "AVI",
  M2T = "M2T",
  TS = "TS",
  WMV = "WMV",
  M4V = "M4V",
  M2V = "M2V",
  M2TS = "M2TS",
  WAV = "WAV",
  AIF = "AIF",
  AIFF = "AIFF",
  MP3 = "MP3",
  M4A = "M4A",
  AC3 = "AC3",
  JPG = "JPG",
  BMP = "BMP",
  PNG = "PNG",
  TIFF = "TIFF",
  TGA = "TGA",
  LSR = "LSR",
  GIF = "GIF",
  DPX = "DPX",
}
